export const ORDER_API_URL =
    "https://script.google.com/macros/s/AKfycbxaXqg7y3n3xA1IMSgFc5li_9te5iWvG-_hv6RrHIDu4K8Ug0ztE_pvph17mqrtQHKU/exec";

let seq = 0;

export class JsonpNetworkError extends Error {}

function abortError() { return new DOMException('Request aborted', 'AbortError'); }

export function jsonp(url, params, { timeout = 45000, signal } = {}) {
    return new Promise((resolve, reject) => {
        if (signal?.aborted) { reject(abortError()); return; }
        const cbName = `__wxJsonp_${Date.now()}_${++seq}`;
        const qs = new URLSearchParams();
        Object.entries(params).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== "") qs.set(k, String(v));
        });
        qs.set("callback", cbName);
        const script = document.createElement("script");
        let timer;
        let settled = false;
        const cleanup = () => {
            clearTimeout(timer);
            signal?.removeEventListener('abort', onAbort);
            delete window[cbName];
            if (script.parentNode) script.parentNode.removeChild(script);
        };
        const finish = (fn, value) => {
            if (settled) return;
            settled = true; cleanup(); fn(value);
        };
        const onAbort = () => finish(reject, abortError());
        window[cbName] = (data) => finish(resolve, data);
        script.onerror = () => finish(reject, new JsonpNetworkError("network"));
        timer = setTimeout(() => finish(reject, new JsonpNetworkError("timeout")), timeout);
        signal?.addEventListener('abort', onAbort, { once: true });
        script.src = `${url}?${qs.toString()}`;
        script.async = true;
        document.head.appendChild(script);
    });
}

export const SLOW_CONNECTION_MSG = "Koneksi sedang lambat. Silakan coba lagi.";

async function fetchFromWebsite(creds, signal) {
    if (signal?.aborted) throw abortError();
    const controller = new AbortController();
    const cancel = () => controller.abort();
    signal?.addEventListener('abort', cancel, { once: true });
    const timer = setTimeout(() => controller.abort(), 52000);
    try {
        const response = await fetch("/api/order-lookup", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(creds),
            cache: "no-store",
            signal: controller.signal,
        });
        if (!response.ok) {
            const error = new JsonpNetworkError("website-api");
            error.authoritative = response.status >= 400 && response.status < 500;
            throw error;
        }
        return await response.json();
    } finally {
        clearTimeout(timer);
        signal?.removeEventListener('abort', cancel);
    }
}

export async function fetchOrder({ whatsapp, code, po_id }, { onRetry, signal } = {}) {
    const creds = { whatsapp, code, ...(po_id !== undefined ? { po_id } : {}) };
    try {
        return await fetchFromWebsite(creds, signal);
    } catch (error) {
        if (signal?.aborted) throw abortError();
        if (error.authoritative) {
            const denied = new Error("Pesanan belum dapat dimuat. Silakan coba lagi.");
            denied.authoritative = true;
            throw denied;
        }
        // The original route remains available if the website backend is down.
        onRetry?.();
        try {
            return await jsonp(ORDER_API_URL, creds, { signal });
        } catch (fallbackError) {
            if (fallbackError instanceof JsonpNetworkError) {
                throw new Error(SLOW_CONNECTION_MSG);
            }
            throw fallbackError;
        }
    }
}


// Image requests preserve the same website-first, JSONP-fallback transport.
// Credentials and image bytes remain in memory only and are never logged.
export async function fetchOrderAsset({ whatsapp, code, po_id }, { kind, id, known_version }, { signal } = {}) {
    if (signal?.aborted) throw abortError();
    const creds = { whatsapp, code, ...(po_id !== undefined ? { po_id } : {}) };
    let result;
    const controller = new AbortController();
    const cancel = () => controller.abort();
    signal?.addEventListener('abort', cancel, { once: true });
    const timer = setTimeout(() => controller.abort(), 52000);
    try {
        const response = await fetch("/api/order-asset", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...creds, kind, id, known_version }),
            cache: "no-store",
            signal: controller.signal,
        });
        if (!response.ok) {
            const error = new JsonpNetworkError("website-api");
            // Explicit request/auth denials must not be retried through another route.
            error.authoritative = response.status >= 400 && response.status < 500;
            throw error;
        }
        result = await response.json();
    } catch (error) {
        clearTimeout(timer);
        if (signal?.aborted) throw abortError();
        if (error.authoritative) throw new Error("Bukti belum dapat dimuat. Silakan coba lagi.");
        try {
            result = await jsonp(ORDER_API_URL, {
                ...creds, action: "asset", asset_kind: kind, asset_id: id, asset_version: known_version,
            }, { signal });
        } catch (fallbackError) {
            if (signal?.aborted || fallbackError.name === 'AbortError') throw abortError();
            throw new Error("Bukti belum dapat dimuat. Silakan coba lagi.");
        }
    } finally {
        clearTimeout(timer);
        signal?.removeEventListener('abort', cancel);
    }
    if (signal?.aborted) throw abortError();
    if (!result?.ok || !result.asset) throw new Error("Bukti belum dapat dimuat. Silakan coba lagi.");
    return result.asset;
}
